import React, { useEffect, useMemo, useState } from "react";
import "../estilos/ConnectApiDocs.css";

const BASE_URL = "https://testqpmini.empatica.mx";

const endpoints = {
  create: {
    group: "Ventas",
    title: "Crear venta",
    method: "POST",
    path: "/generarCodigoImagenPago",
    description:
      "Genera una venta pendiente y su código de pago para que pueda ser procesada por cualquiera de los cajeros conectados al servidor.",
    body: {
      folioVenta: "VENTA-1001",
      usuario: "demo",
      monto: 150.0,
      montoReal: 150.0,
      tipoPago: "EFECTIVO",
      subtotal: 129.31,
      IVA: 20.69,
      IdStatus: 0,
      vendedor: "Caja 1",
      onlyCode: 1,
      TipoRecibo: "COMPLETO",
      noTickets: 1,
      fechaLimite: "2026-09-30",
      datos: [
        {
          cantidad: 1,
          producto: "Producto demo",
          monto: 150.0,
          subtotal: 129.31,
          IVA: 20.69,
          IVA_Porcen: 16,
          PrecioUnitarioVenta: 150.0,
          UM: "Pz",
          Categoria: "General",
          SubCategoria: ""
        }
      ]
    },
    fields: [
      ["folioVenta", "String", "Sí", "Folio único de la venta en tu sistema."],
      ["usuario", "String", "Sí", "Usuario o identificador del origen de la venta."],
      ["monto", "Number", "Sí", "Monto a cobrar, máximo 2 decimales."],
      ["montoReal", "Number", "Sí", "Monto real antes de cualquier redondeo."],
      ["tipoPago", "String", "Sí", 'EFECTIVO, TARJETA o "" para selección.'],
      ["datos", "Array", "Sí", "Productos relacionados con la venta."],
      ["IdStatus", "Number", "No", "Estado de la venta. Consulta la referencia de estados."],
      ["fechaLimite", "String", "No", "Fecha de vigencia en formato YYYY-MM-DD."],
      ["onlyCode", "Number", "No", "1 evita retornar imágenes Base64; 0 las incluye."]
    ]
  },
  devices: {
    group: "Cajeros",
    title: "Listar cajeros",
    method: "POST",
    path: "/getCajerosSlave",
    description:
      "Obtiene los cajeros asociados a la empresa del token. Puedes consultar equipos activos, inactivos o todos.",
    body: { filtro: "ACTIVO" },
    fields: [
      ["filtro", "String", "No", "ACTIVO, INACTIVO o TODO. Por defecto ACTIVO."]
    ]
  },
  status: {
    group: "Ventas",
    title: "Consultar venta",
    method: "POST",
    path: "/getStatusVenta",
    description:
      "Consulta la información más reciente de una venta usando el folio externo o la clave de transacción.",
    body: { folioVenta: "VENTA-1001" },
    fields: [
      ["folioVenta", "String", "Sí", "Folio externo o clave de transacción de la venta."]
    ]
  },
  expiry: {
    group: "Ventas",
    title: "Actualizar vencimiento",
    method: "POST",
    path: "/updateFechaLimiteVenta",
    description:
      "Actualiza la fecha límite de una venta que todavía se encuentre pendiente.",
    body: { folioVenta: "VENTA-1001", fechaLimite: "2026-09-30" },
    fields: [
      ["folioVenta", "String", "Sí", "Folio de la venta pendiente."],
      ["fechaLimite", "String", "Sí", "Nueva fecha límite en formato YYYY-MM-DD."]
    ]
  },
  cancel: {
    group: "Ventas",
    title: "Cancelar venta",
    method: "POST",
    path: "/cancelarVenta",
    description:
      "Cancela una venta pendiente. Puedes identificarla por folioVenta o claveTransaccion.",
    body: { usuario: "demo", folioVenta: "VENTA-1001" },
    fields: [
      ["usuario", "String", "Sí", "Usuario que solicita la cancelación."],
      ["folioVenta", "String", "Condicional", "Folio externo de la venta."],
      ["claveTransaccion", "String", "Condicional", "Clave de transacción. Puede utilizarse en lugar de folioVenta."]
    ]
  },
  refund: {
    group: "Devoluciones",
    title: "Generar código de devolución",
    method: "POST",
    path: "/generarCodigoImagenDevolucion",
    description:
      "Genera un código de devolución para una venta que ya se encuentre pagada.",
    body: { folioVenta: "VENTA-1001" },
    fields: [
      ["folioVenta", "String", "Sí", "Folio de una venta pagada."]
    ]
  }
};

const nav = [
  ["overview", "Empezar", "Overview"],
  ["quickstart", "Empezar", "Quickstart"],
  ["auth", "Empezar", "Autenticación"],
  ["devices", "Cajeros", "Listar cajeros"],
  ["create", "Ventas", "Crear venta"],
  ["status", "Ventas", "Consultar venta"],
  ["expiry", "Ventas", "Actualizar vencimiento"],
  ["cancel", "Ventas", "Cancelar venta"],
  ["refund", "Devoluciones", "Generar código"],
  ["webhooks", "Eventos", "Webhooks"],
  ["websocket", "Eventos", "WebSocket"],
  ["statusref", "Referencia", "Estados de venta"],
  ["errors", "Referencia", "Errores e idempotencia"]
];

export default function ConnectApiDocs() {
  const initial = getRouteKey();
  const [page, setPage] = useState(initial);
  const [token, setToken] = useState("");
  const [showToken, setShowToken] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("connectDocsMenuOpen");
    } else {
      document.body.classList.remove("connectDocsMenuOpen");
    }

    return () => document.body.classList.remove("connectDocsMenuOpen");
  }, [menuOpen]);

  useEffect(() => {
    document.body.classList.add("connectApiDocsPage");
    return () => document.body.classList.remove("connectApiDocsPage");
  }, []);


  const navigate = (key) => {
    setPage(key);
    const path = key === "overview"
      ? "/developers/connect-api"
      : `/developers/connect-api/${routeForKey(key)}`;
    window.history.pushState({}, "", path);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="connectDocs">
      <header className="docsTop">
        <div className="docsTopLeft">
          <button
            className="mobileMenuButton"
            onClick={() => setMenuOpen(true)}
            aria-label="Abrir menú"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="docsBrand">
            <img src={require("../recursos/empatica-hor.png")} alt="Empática" />
            <span className="docsDivider" />
            <strong>Connect API</strong>
            <span className="sandboxBadge">Sandbox</span>
          </div>
        </div>

        <div className="tokenBar">
          <span className="tokenLabel">Token de pruebas</span>
          <div className="tokenInputWrap">
            <input
              value={token}
              onChange={(e) => setToken(e.target.value)}
              type={showToken ? "text" : "password"}
              placeholder="Ingresa tu token"
            />
            <button onClick={() => setShowToken(!showToken)}>
              {showToken ? "Ocultar" : "Ver"}
            </button>
          </div>
        </div>
      </header>

      <button
        className={`sidebarBackdrop ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(false)}
        aria-label="Cerrar menú"
      />

      <aside className={`docsSidebar ${menuOpen ? "open" : ""}`}>
        <div className="mobileSidebarHeader">
          <div>
            <strong>Connect API</strong>
            <span>Documentación</span>
          </div>
          <button
            className="closeSidebarButton"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar menú"
          >
            ×
          </button>
        </div>

        <div className="sidebarDesktopContent">
          <div className="sidebarTitle">DOCUMENTACIÓN</div>
          {renderNav(page, navigate)}
          <div className="sidebarSandbox">
            <span>Ambiente de pruebas</span>
            <code>{BASE_URL}</code>
          </div>
        </div>
      </aside>

      <div className="docsShell">
        <main className="docsMain">
          {page === "overview" && <Overview navigate={navigate} />}
          {page === "quickstart" && <Quickstart navigate={navigate} />}
          {page === "auth" && <Authentication token={token} />}
          {page === "webhooks" && <Webhooks />}
          {page === "websocket" && <WebSocketDocs />}
          {page === "statusref" && <StatusReference />}
          {page === "errors" && <Errors />}
          {endpoints[page] && (
            <EndpointPage
              key={page}
              endpoint={endpoints[page]}
              token={token}
              setToken={setToken}
            />
          )}
        </main>
      </div>
    </div>
  );
}

function renderNav(page, navigate) {
  const groups = [...new Set(nav.map((x) => x[1]))];
  return groups.map((group) => (
    <div className="navGroup" key={group}>
      <div className="navGroupTitle">{group}</div>
      {nav.filter((x) => x[1] === group).map(([key, , label]) => (
        <button
          key={key}
          className={`navItem ${page === key ? "active" : ""}`}
          onClick={() => navigate(key)}
        >
          {label}
        </button>
      ))}
    </div>
  ));
}

function Overview({ navigate }) {
  return (
    <div className="contentPage">
      <span className="sectionKicker">CONNECT API</span>
      <h1>Integra pagos con una sola conexión.</h1>
      <p className="lead">
        Connect API permite que tu sistema envíe ventas al servidor de Empática y
        que uno o múltiples cajeros conectados puedan procesarlas.
      </p>

      <div className="architectureCard">
        <div className="architectureFlow">
          <FlowNode title="Sistema integrador" subtitle="Nube o servidor local" />
          <FlowArrow />
          <FlowNode title="Servidor Empática" subtitle="Connect API" primary />
          <FlowArrow />
          <div className="deviceStack">
            <FlowNode title="Cajero 1" compact />
            <FlowNode title="Cajero 2" compact />
            <FlowNode title="Cajero N" compact />
          </div>
        </div>
      </div>

      <div className="infoGrid">
        <InfoCard title="Crear una venta" text="Genera el código que el cliente utilizará para pagar." action="Ver endpoint" onClick={() => navigate("create")} />
        <InfoCard title="Consultar cajeros" text="Obtén los cajeros asociados a tu integración y su estado." action="Ver cajeros" onClick={() => navigate("devices")} />
        <InfoCard title="Recibir eventos" text="Recibe la confirmación del pago mediante Webhook o WebSocket." action="Configurar eventos" onClick={() => navigate("webhooks")} />
      </div>

      <div className="callout">
        <strong>Sandbox listo para pruebas</strong>
        <span>Todos los ejemplos interactivos de esta documentación apuntan a <code>{BASE_URL}</code>.</span>
      </div>
    </div>
  );
}

function Quickstart({ navigate }) {
  const steps = [
    ["1", "Obtén tu token", "El token identifica a tu empresa y se utiliza en las operaciones de Connect API."],
    ["2", "Consulta tus cajeros", "Verifica qué cajeros se encuentran asociados y disponibles."],
    ["3", "Crea una venta", "Envía el folio, monto, productos y demás información de la operación."],
    ["4", "Procesa el pago", "El cliente presenta el código generado en uno de los cajeros conectados."],
    ["5", "Recibe terminoPago", "Tu sistema recibe la confirmación y registra la venta como pagada."]
  ];

  return (
    <div className="contentPage">
      <span className="sectionKicker">QUICKSTART</span>
      <h1>Tu primer pago en 5 pasos.</h1>
      <p className="lead">Este flujo cubre la integración básica de principio a fin.</p>
      <div className="steps">
        {steps.map(([n, title, text]) => (
          <div className="step" key={n}>
            <div className="stepNumber">{n}</div>
            <div><h3>{title}</h3><p>{text}</p></div>
          </div>
        ))}
      </div>
      <button className="primaryBtn" onClick={() => navigate("devices")}>Comenzar con tus cajeros →</button>
    </div>
  );
}

function Authentication({ token }) {
  return (
    <div className="contentPage">
      <span className="sectionKicker">AUTENTICACIÓN</span>
      <h1>Autentica tus solicitudes con un token.</h1>
      <p className="lead">
        Para realizar peticiones a Connect API necesitas un token de integración válido.
        Este token se incluye en las solicitudes para autenticar y autorizar las operaciones.
      </p>

      <div className="callout success">
        <strong>Recomendación</strong>
        <span>No expongas el token en repositorios públicos. Para producción, las llamadas deben originarse desde tu backend.</span>
      </div>

      <h2>Token actual</h2>
      <div className="codeStatic">{token ? mask(token) : "Aún no has ingresado un token en la barra superior."}</div>
    </div>
  );
}

function EndpointPage({ endpoint, token, setToken }) {
  const [formData, setFormData] = useState(() => JSON.parse(JSON.stringify(endpoint.body)));
  const [lang, setLang] = useState("curl");
  const [result, setResult] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const payload = useMemo(
    () => ({ ...formData, token }),
    [formData, token]
  );

  const snippet = generateSnippet(
    lang,
    endpoint,
    { ...formData, token: token || "TU_TOKEN" }
  );

  const updateField = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: normalizeInputValue(prev[key], value)
    }));
  };

  const updateProductField = (index, key, value) => {
    setFormData((prev) => {
      const next = { ...prev };
      next.datos = Array.isArray(prev.datos)
        ? prev.datos.map((item, i) =>
            i === index
              ? { ...item, [key]: normalizeInputValue(item[key], value) }
              : item
          )
        : [];
      return next;
    });
  };

  const send = async () => {
    if (!token.trim()) {
      setStatus("Token requerido");
      setResult({
        msg: "LOCAL",
        respuesta: "Ingresa el token de pruebas en la barra superior."
      });
      return;
    }

    setLoading(true);
    setResult(null);
    setStatus("Enviando...");
    const started = performance.now();

    try {
      const response = await fetch(`${BASE_URL}${endpoint.path}`, {
        method: endpoint.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const ms = Math.round(performance.now() - started);
      const raw = await response.text();

      let data;
      try {
        data = JSON.parse(raw);
      } catch {
        data = raw;
      }

      setStatus(`${response.status} ${response.statusText || ""} · ${ms} ms`);
      setResult(data);
    } catch (error) {
      setStatus("Error de conexión");
      setResult({
        msg: "NETWORK_ERROR",
        respuesta: error.message,
        ayuda: "Verifica CORS, conexión al sandbox y disponibilidad del servidor."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="endpointLayout endpointLayoutStable">
      <section className="endpointContent endpointContentStable">
        <span className="sectionKicker">{endpoint.group.toUpperCase()}</span>
        <h1>{endpoint.title}</h1>

        <div className="endpointPath">
          <span className="method post">{endpoint.method}</span>
          <code>{endpoint.path}</code>
        </div>

        <p className="lead small">{endpoint.description}</p>

        <h2>Parámetros</h2>
        <div className="paramsTable">
          <div className="paramsHead">
            <span>Campo</span>
            <span>Tipo</span>
            <span>Requerido</span>
            <span>Descripción</span>
          </div>

          <ParamRow
            name="token"
            type="String"
            req="Sí"
            desc="Token de autenticación de la empresa."
          />

          {endpoint.fields.map(([n, t, r, d]) => (
            <ParamRow key={n} name={n} type={t} req={r} desc={d} />
          ))}
        </div>

        <h2>Request body</h2>
        <p className="payloadHelp">
          Modifica únicamente los valores. Los nombres y la estructura del payload están protegidos.
        </p>

        <div className="payloadForm">
          {Object.entries(formData).map(([key, value]) => {
            if (key === "datos" && Array.isArray(value)) {
              return (
                <div className="payloadGroup" key={key}>
                  <div className="payloadFieldLabel">
                    <code>{key}</code>
                    <span>Array</span>
                  </div>

                  <div className="productList">
                    {value.map((item, index) => (
                      <div className="productCard" key={index}>
                        <div className="productCardTitle">
                          Producto {index + 1}
                        </div>

                        <div className="productFields">
                          {Object.entries(item).map(([productKey, productValue]) => (
                            <LockedField
                              key={productKey}
                              fieldKey={productKey}
                              value={productValue}
                              onChange={(nextValue) =>
                                updateProductField(index, productKey, nextValue)
                              }
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <LockedField
                key={key}
                fieldKey={key}
                value={value}
                onChange={(nextValue) => updateField(key, nextValue)}
              />
            );
          })}

          <div className="payloadField tokenField">
            <div className="payloadFieldLabel">
              <code>token</code>
              <span>String</span>
            </div>

            <input
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Ingresa tu token de pruebas"
            />
          </div>
        </div>

        <details className="jsonPreview">
          <summary>Ver JSON generado</summary>
          <pre>
            <code>{JSON.stringify(payload, null, 2)}</code>
          </pre>
        </details>

        <div className="mobilePlayground">
          <PlaygroundPanel
            endpoint={endpoint}
            lang={lang}
            setLang={setLang}
            snippet={snippet}
            result={result}
            status={status}
            loading={loading}
            send={send}
          />
        </div>
      </section>

      <aside className="playground desktopPlayground">
        <PlaygroundPanel
          endpoint={endpoint}
          lang={lang}
          setLang={setLang}
          snippet={snippet}
          result={result}
          status={status}
          loading={loading}
          send={send}
        />
      </aside>
    </div>
  );
}

function PlaygroundPanel({
  endpoint,
  lang,
  setLang,
  snippet,
  result,
  status,
  loading,
  send
}) {
  return (
    <>
      <div className="playgroundTop">
        <div>
          <span className="playLabel">SANDBOX</span>
          <code>{BASE_URL}</code>
        </div>

        <button
          className="sendBtn"
          onClick={send}
          disabled={loading}
        >
          {loading ? "Enviando..." : "Enviar request →"}
        </button>
      </div>

      <div className="langTabs">
        {["curl", "javascript", "csharp", "python", "php", "java"].map((x) => (
          <button
            className={lang === x ? "active" : ""}
            onClick={() => setLang(x)}
            key={x}
          >
            {labelLang(x)}
          </button>
        ))}
      </div>

      <pre className="codeBlock">
        <code>{snippet}</code>
      </pre>

      <div className="responseHead">
        <strong>Response</strong>
        <span>{status || "Sin ejecutar"}</span>
      </div>

      <pre className="responseBlock">
        <code>{result ? pretty(result) : "// La respuesta aparecerá aquí."}</code>
      </pre>
    </>
  );
}

function LockedField({ fieldKey, value, onChange }) {
  const type = typeof value;

  if (type === "boolean") {
    return (
      <div className="payloadField">
        <div className="payloadFieldLabel">
          <code>{fieldKey}</code>
          <span>Boolean</span>
        </div>
        <select
          value={String(value)}
          onChange={(e) => onChange(e.target.value === "true")}
        >
          <option value="true">true</option>
          <option value="false">false</option>
        </select>
      </div>
    );
  }

  return (
    <div className="payloadField">
      <div className="payloadFieldLabel">
        <code>{fieldKey}</code>
        <span>{type === "number" ? "Number" : "String"}</span>
      </div>

      <input
        type={type === "number" ? "number" : "text"}
        step={type === "number" ? "any" : undefined}
        value={value == null ? "" : value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function normalizeInputValue(originalValue, nextValue) {
  if (typeof originalValue === "number") {
    if (nextValue === "") return "";
    const parsed = Number(nextValue);
    return Number.isNaN(parsed) ? nextValue : parsed;
  }

  return nextValue;
}

function Webhooks() {
  const example = {
    clave: "terminoPago",
    usuario: "demo",
    folioVenta: "VENTA-1001",
    monto: "150.00",
    ingresado: "200.00",
    cambioDispensado: "50.00",
    tipoPago: "EFECTIVO",
    status: 1,
    statusTexto: "Cobro pagado exitosamente.",
    claveCajero: "QP-001",
    fechaHora: "2026-09-24T13:30:00",
    claveTransaccion: "..."
  };

  return (
    <div className="contentPage">
      <span className="sectionKicker">EVENTOS</span>
      <h1>Webhooks</h1>
      <p className="lead">
        Configura un endpoint POST en tu sistema para recibir eventos como <code>terminoPago</code>.
        Connect API puede reenviar una operación cuando todavía no ha sido confirmada.
      </p>
      <h2>Ejemplo de evento</h2>
      <pre className="wideCode"><code>{JSON.stringify(example, null, 2)}</code></pre>
      <h2>Respuesta esperada</h2>
      <pre className="wideCode"><code>{JSON.stringify({msg:"200", folioVenta:"VENTA-1001"}, null, 2)}</code></pre>
    </div>
  );
}

function WebSocketDocs() {
  const domainExample = `wss://testqpmini.empatica.mx/ws?authorization=TU_TOKEN`;
  const localExample = `ws://192.168.1.50:7071/?authorization=TU_TOKEN`;

  return (
    <div className="contentPage">
      <span className="sectionKicker">EVENTOS</span>
      <h1>WebSocket</h1>
      <p className="lead">
        Mantén una conexión persistente para recibir eventos de Connect API en tiempo real.
        El token se envía desde el momento en que se establece la conexión.
      </p>

      <h2>Construir la conexión</h2>

      <div className="wsOptionGrid">
        <div className="wsOption">
          <span className="wsOptionBadge">Dominio + SSL</span>
          <strong>Usa WSS</strong>
          <code>{domainExample}</code>
          <p>Para un dominio público con certificado SSL se utiliza <strong>wss://</strong>.</p>
        </div>

        <div className="wsOption">
          <span className="wsOptionBadge local">Red local</span>
          <strong>Usa WS</strong>
          <code>{localExample}</code>
          <p>
            Si Connect API está instalado en un servidor local accesible por IP,
            la comunicación se realiza por <strong>ws://</strong> en el puerto <strong>7071</strong>.
          </p>
        </div>
      </div>

      <div className="callout">
        <strong>Authorization</strong>
        <span>
          El token se envía como query parameter:
          <code> ?authorization=TU_TOKEN</code>.
        </span>
      </div>

      <h2>Registrar el sistema integrador</h2>
      <p>
        Después de abrir correctamente el socket, registra el usuario que recibirá
        los eventos de la empresa:
      </p>

      <pre className="wideCode"><code>{JSON.stringify({
        clave: "nuevoUsuario",
        usuario: "MI_USUARIO",
        token: "TU_TOKEN"
      }, null, 2)}</code></pre>
    </div>
  );
}

function StatusReference() {
  const statuses = [
    {
      id: 0,
      label: "Pendiente",
      className: "pending",
      description: "La venta fue generada y aún está disponible para pago."
    },
    {
      id: 1,
      label: "Pagada",
      className: "paid",
      description: "La venta fue cobrada correctamente."
    },
    {
      id: 2,
      label: "Expirada / Cancelada",
      className: "cancelled",
      description: "La venta ya no está disponible para pago porque expiró o fue cancelada."
    },
    {
      id: 3,
      label: "Devuelta",
      className: "refunded",
      description: "La venta fue marcada como devuelta."
    }
  ];

  return (
    <div className="contentPage">
      <span className="sectionKicker">REFERENCIA</span>
      <h1>Estados de venta</h1>
      <p className="lead">
        El campo <code>IdStatus</code> indica el estado actual de una venta dentro de Connect API.
      </p>

      <div className="statusReferenceGrid">
        {statuses.map((status) => (
          <div className="statusReferenceCard" key={status.id}>
            <div className="statusReferenceTop">
              <span className={`statusPill ${status.className}`}>
                {status.id}
              </span>
              <strong>{status.label}</strong>
            </div>
            <p>{status.description}</p>
          </div>
        ))}
      </div>

     {/* <div className="statusTable">
        <div className="statusTableHead">
          <span>IdStatus</span>
          <span>Estado</span>
          <span>Significado</span>
        </div>

        {statuses.map((status) => (
          <div className="statusTableRow" key={status.id}>
            <code>{status.id}</code>
            <span>
              <span className={`statusDot ${status.className}`}></span>
              {status.label}
            </span>
            <span>{status.description}</span>
          </div>
        ))}
      </div>*/}

      <div className="callout">
        <strong>Uso en los endpoints</strong>
        <span>
          Cuando un endpoint devuelva o reciba <code>IdStatus</code>, utiliza esta tabla como referencia del estado de la venta.
        </span>
      </div>
    </div>
  );
}

function Errors() {
  return (
    <div className="contentPage">
      <span className="sectionKicker">REFERENCIA</span>
      <h1>Errores e idempotencia</h1>
      <p className="lead">La API utiliza principalmente <code>msg: "200"</code> para operaciones correctas y <code>msg: "300"</code> para errores funcionales.</p>
      <div className="infoGrid two">
        <InfoCard title='msg "200"' text="La operación fue procesada correctamente." />
        <InfoCard title='msg "300"' text="La solicitud no pudo completarse; revisa el campo respuesta." />
      </div>
      <h2>Evitar duplicados</h2>
      <p>
        Utiliza folios únicos para cada venta. El servidor también contiene mecanismos para detectar operaciones
        concurrentes y flujos de idempotencia en determinadas variantes del endpoint.
      </p>
    </div>
  );
}

function ParamRow({name,type,req,desc}) {
  return <div className="paramRow"><code>{name}</code><span>{type}</span><span>{req}</span><span>{desc}</span></div>;
}
function FlowNode({title,subtitle,primary,compact}) {
  return <div className={`flowNode ${primary?"primary":""} ${compact?"compact":""}`}><strong>{title}</strong>{subtitle&&<span>{subtitle}</span>}</div>;
}
function FlowArrow(){return <span className="flowArrow">→</span>;}
function InfoCard({title,text,action,onClick}) {
  return <div className="infoCard"><h3>{title}</h3><p>{text}</p>{action&&<button onClick={onClick}>{action} →</button>}</div>;
}
function pretty(x){ return typeof x === "string" ? x : JSON.stringify(x,null,2); }
function mask(x){ return x.length <= 8 ? "••••••••" : `${x.slice(0,4)}${"•".repeat(Math.min(20,x.length-8))}${x.slice(-4)}`; }
function labelLang(x){return ({curl:"cURL",javascript:"JavaScript",csharp:"C#",python:"Python",php:"PHP",java:"Java"})[x];}

function routeForKey(key) {
  return ({
    quickstart:"quickstart",
    auth:"authentication",
    devices:"devices",
    create:"payments/create",
    status:"payments/status",
    expiry:"payments/expiry",
    cancel:"payments/cancel",
    refund:"refunds/create",
    webhooks:"events/webhooks",
    websocket:"events/websocket",
    statusref:"reference/status",
    errors:"reference/errors"
  })[key] || "";
}

function getRouteKey() {
  const p = window.location.pathname.replace(/\/+$/,"");
  if (p.endsWith("/quickstart")) return "quickstart";
  if (p.endsWith("/authentication")) return "auth";
  if (p.endsWith("/devices")) return "devices";
  if (p.endsWith("/payments/create")) return "create";
  if (p.endsWith("/payments/status")) return "status";
  if (p.endsWith("/payments/expiry")) return "expiry";
  if (p.endsWith("/payments/cancel")) return "cancel";
  if (p.endsWith("/refunds/create")) return "refund";
  if (p.endsWith("/events/webhooks")) return "webhooks";
  if (p.endsWith("/events/websocket")) return "websocket";
  if (p.endsWith("/reference/status")) return "statusref";
  if (p.endsWith("/reference/errors")) return "errors";
  return "overview";
}

function generateSnippet(lang, endpoint, body) {
  const url = `${BASE_URL}${endpoint.path}`;
  const json = JSON.stringify(body, null, 2);
  if (lang === "curl") return `curl -X ${endpoint.method} '${url}' \\\n  -H 'Content-Type: application/json' \\\n  -d '${json}'`;
  if (lang === "javascript") return `const response = await fetch("${url}", {\n  method: "${endpoint.method}",\n  headers: { "Content-Type": "application/json" },\n  body: JSON.stringify(${json})\n});\n\nconst data = await response.json();\nconsole.log(data);`;
  if (lang === "csharp") return `using System.Net.Http;\nusing System.Text;\n\nvar client = new HttpClient();\nvar json = @"${json.replace(/"/g,'""')}";\nvar content = new StringContent(json, Encoding.UTF8, "application/json");\nvar response = await client.PostAsync("${url}", content);\nvar result = await response.Content.ReadAsStringAsync();`;
  if (lang === "python") return `import requests\n\nurl = "${url}"\npayload = ${json.replace(/\btrue\b/g,"True").replace(/\bfalse\b/g,"False").replace(/\bnull\b/g,"None")}\n\nresponse = requests.post(url, json=payload)\nprint(response.json())`;
  if (lang === "php") return `$payload = ${JSON.stringify(JSON.stringify(body))};\n$ch = curl_init("${url}");\ncurl_setopt($ch, CURLOPT_POST, true);\ncurl_setopt($ch, CURLOPT_HTTPHEADER, ["Content-Type: application/json"]);\ncurl_setopt($ch, CURLOPT_POSTFIELDS, $payload);\ncurl_setopt($ch, CURLOPT_RETURNTRANSFER, true);\n$response = curl_exec($ch);\ncurl_close($ch);\necho $response;`;
  return `var client = java.net.http.HttpClient.newHttpClient();\nvar request = java.net.http.HttpRequest.newBuilder()\n    .uri(java.net.URI.create("${url}"))\n    .header("Content-Type", "application/json")\n    .POST(java.net.http.HttpRequest.BodyPublishers.ofString("""\n${json}\n"""))\n    .build();\n\nvar response = client.send(request,\n    java.net.http.HttpResponse.BodyHandlers.ofString());\nSystem.out.println(response.body());`;
}
